import * as imageFilters from './imageFilters'
import * as localeFilters from './localeFilters'

const filters = {
  ...imageFilters,
  ...localeFilters
}

export default {
  install(Vue) {
    for (const [name, fn] of Object.entries(filters)) {
      Vue.filter(name, fn)
    }
  }
}